/**
 * @lines98/client/components/text — примитив «текст с ролью».
 *
 * ЗАЧЕМ (owner-directive 2026-06-04 «делаем примитивы»). Размер шрифта — НИКОГДА не
 * сырое число; он идёт от роли (заголовок / подзаголовок / тело / подпись / контрол),
 * а роль → токен --fs-*. Создаёшь текст ролью — размер-токен и границы наследуются
 * из ОДНОГО места, их негде вписать руками (это и ловил бы CSS-гейт, а примитив
 * убирает сам повод). Модель «ствол → ветки»: экран пишет текст, правила — в кирпичике.
 *
 * Роли → токены (global.css :root):
 *   title → --fs-title · subtitle → --fs-subtitle · body → --fs-body ·
 *   label → --fs-label · control → --fs-control (кнопки/заголовки экранов).
 *
 * Размер задаёт ТОЛЬКО роль (класс .txt--<role>); вес/тон — необязательные
 * модификаторы. Никаких inline-размеров. CSS — co-located `text.css`.
 */

import './text.css';

export type TextRole = 'title' | 'subtitle' | 'body' | 'label' | 'control';
export type TextWeight = 400 | 600 | 700 | 800;
export type TextTone = 'default' | 'soft' | 'accent';

export interface TextOptions {
  /** Роль → размер-токен --fs-*. Единственный источник размера. */
  readonly role: TextRole;
  /** Текст (textContent — без HTML-инъекций). */
  readonly text: string;
  /** Тег (по умолчанию 'span'; для заголовков — 'h1'..'h3', абзацев — 'p'). */
  readonly as?: keyof HTMLElementTagNameMap;
  /** Насыщенность (необязательно). */
  readonly weight?: TextWeight;
  /** Цвет-тон (необязательно): default = inherit, soft, accent. */
  readonly tone?: TextTone;
  /** Доп. класс(ы) экрана-потребителя (hook/позиционирование, не размер). */
  readonly className?: string;
}

export interface TextHandle {
  readonly element: HTMLElement;
  /** Обновить текст (textContent). */
  setText(text: string): void;
}

/** Создать текст с ролью. Возвращает handle с `.element`. */
export function createText(opts: TextOptions): TextHandle {
  const el = document.createElement(opts.as ?? 'span');
  el.classList.add('txt', `txt--${opts.role}`);
  if (opts.weight) el.classList.add(`txt--w${opts.weight}`);
  if (opts.tone && opts.tone !== 'default') el.classList.add(`txt--${opts.tone}`);
  if (opts.className) el.classList.add(...opts.className.split(/\s+/).filter(Boolean));
  el.textContent = opts.text;
  return {
    element: el,
    setText(text: string): void {
      el.textContent = text;
    },
  };
}
